import { UploadCommonService } from '@1bill-app/services/upload/common/upload-common.service';
import { UploadService } from '@1bill-app/services/upload/upload.service';
import { UploadStore } from '@1bill-app/services/upload/upload.store';
import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ModalController, NavController, PopoverController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { EXPLANATION_NOTES_SIMPLE, ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { UploadFileModalComponent } from '@1bill-app/components/modals/upload-file-modal/upload-file-modal.component';
import { StatusService } from '@1bill-app/services/status/status.service';
import { PopoverInfoIconComponent } from '@1bill-app/components/popover/popover-info-icon/popover-info-icon.component';

@Component({
  selector: 'app-take-photo',
  templateUrl: './take-photo.page.html',
  styleUrls: ['./take-photo.page.scss'],
})
export class TakePhotoPage implements OnInit, OnDestroy {
  uploadProgress: number;
  isUploading: boolean;
  error: any;
  errorCode: any;
  productType: string;
  get photoBills() {
    return this.uploadService.photoBills.map((b) => {
      delete b.progress;
      return b;
    });
  }

  constructor(
    private uploadService: UploadService,
    private _uploadCommon: UploadCommonService,
    private uploadStore: UploadStore,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private logger: NGXLogger,
    private ngZone: NgZone,
    private alertController: AlertController,
    private modalCtrl: ModalController,
    private statusService: StatusService,
    private popoverController: PopoverController
  ) {}

  ngOnInit() {
    const bills = this.getPhotoBills();
    this.logger.debug('bills,', bills);

    if (bills.length == 0) {
      this.navCtrl.navigateRoot([ROUTE_HOMEPAGE]);
    }
    this.productType = this.route.snapshot.queryParamMap.get('productType');
    this.logger.debug('this.productType', this.productType);
  }
  ngOnDestroy(): void {
    this.logger.log('ngOnDestroy');

    this.uploadService.clearPhotoBillsUpload();
  }
  upload(event, uploadMediaType: 'PDF' | 'PHOTO', dragAndDrop: boolean = false) {
    // this._uploadCommon.upload(event, uploadMediaType, dragAndDrop);
    this._uploadCommon.upload({
      event,
      uploadMediaType,
      dragAndDrop,
      productType: this.productType,
    });
  }
  getPhotoBills() {
    return this.uploadService.photoBills.map((b) => {
      delete b.progress;
      return b;
    });
  }

  async onFinishUpload() {
    if (this.photoBills.length == 1) {
      const alert = await this.alertController.create({
        cssClass: 'bill-alert',
        header: 'Sure to proceed?',
        message: `Only one page of the bill has been added. Are you sure you have included all 
        the pages of the bill and want to proceed?`,
        mode: 'ios',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              this.logger.log('Confirm Cancel: blah');
            },
          },
          {
            text: 'Proceed',
            handler: () => {
              // this.ngZone.run(async () => {
              this.onFinishUploadFinal();
              // });
            },
          },
        ],
      });

      await alert.present();
    } else {
      await this.onFinishUploadFinal();
    }
  }

  async onFinishUploadFinal() {
    // const pdf = this.convertImageToPdf();
    // Initialize
    this.uploadStore.update({ isUploading: true, hasUploaded: true, hasUploadErr: false });
    try {
      // await this._uploadCommon.fileIsUploading('IMG');
      const modal = await this.modalCtrl.create({
        component: UploadFileModalComponent,
        cssClass: 'my-custom-class',
        backdropDismiss: false,
        id: 'file-uploading-modal',
        componentProps: {
          source: 'IMG',
        },
      });

      await modal.present();

      const imgURLs = this.uploadService.photoBills.map((p) => p.s3Key); // s3-url-to-key

      modal.onWillDismiss().then(async (dismiss) => {
        this.logger.debug(dismiss);
        if (dismiss.data.cusSelected) {
          this.statusService.updateJobMeta(dismiss.data);
        }

        // emit value to parent component
        const value = { target: { files: null, imgs: imgURLs } };
        // this.upload.emit(value);
        this.upload(value, 'PHOTO');
        // this.loading = false;
        this.uploadStore.update({
          isUploading: false,
          hasUploaded: true,
          hasUploadErr: false,
        });
        if (dismiss.role === 'go-home') {
          this.navCtrl.navigateRoot([ROUTE_HOMEPAGE], { queryParams: { job: true } });
        }


      this.presentuploadSuccess();

      });
      return;
    } catch (e) {
      this.logger.info('onFinishUpload', { error: e });
      this.uploadStore.update({ isUploading: false, hasUploaded: false, hasUploadErr: true });
    }
  }


  
  async presentuploadSuccess() {
    const popover = await this.popoverController.create({
      component: PopoverInfoIconComponent,
      cssClass: 'popover-info-icon-modal',
      // translucent: true,
      mode: 'ios',
      componentProps: {
        iconSource: EXPLANATION_NOTES_SIMPLE.BILL_UPLOAD_SUCCESS_ICON,
        popoverTitle: EXPLANATION_NOTES_SIMPLE.BILL_UPLOAD_SUCCESS_TITLE,
        description: EXPLANATION_NOTES_SIMPLE.BILL_UPLOAD_SUCCESS_DESC,
        descriptionTwo: EXPLANATION_NOTES_SIMPLE.BILL_UPLOAD_SUCCESS_DESC_TWO,
      },
    });
    return await popover.present();
  }
}
